import { axiosInstance } from "./apiConfig"

export const apiUpdateCustomer = async ({
    storeId, customerId, name, surname, mobilePhoneCountryCode, mobilePhone, specialRequests,
    email, receiveEmailMarketing, emailMarketingOptInText
}) => {
    try {
        const response = await axiosInstance.post(
            `/thirdparty/resdiary/store/${storeId}/customer/${customerId}`,
            `&FirstName=${name}` +
            `&Surname=${surname}` +
            `&MobileCountryCode=${mobilePhoneCountryCode}` +
            `&Mobile=${mobilePhone}` +
            `&Email=${email}` +
            `&Comments=${specialRequests}` +
            `&ReceiveEmailMarketing=${receiveEmailMarketing}` +
            `&ReceiveRestaurantEmailMarketing=${receiveEmailMarketing}` +
            `&GroupEmailMarketingOptInText=${emailMarketingOptInText}` +
            `&RestaurantEmailMarketingOptInText=${emailMarketingOptInText}` +
            `&CustomerOptions[AppendComments]=false`,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
        console.log(response.data)
        return response.data;
    } catch (error) {
        // Don't throw error
        console.log(error);
    }
}


// WEBPACK FOOTER //
// ./src/api/apiUpdateCustomer.js